module.exports = __webpack_public_path__ + "img/currencyBack3.69a66c17.png";